export function renderOEmbed() {
	document.querySelectorAll("oembed[url]").forEach( element => {
		let vCode = (element as any).attributes.url.value.split("?v=")[1];
		(element as any).parentElement.innerHTML = `
			<iframe
				src="https://www.youtube.com/embed/${vCode}?rel=0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			>
			</iframe>`;
	});
}
window.addEventListener('load', renderOEmbed);
